import styled from "styled-components";

const StyledManualInputPage = styled.div`
  max-width: 512px;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    max-width: unset;
  }
`;

export default StyledManualInputPage;
